import {
  Avatar,
  Box,
  CssBaseline,
  Grid,
  Typography,
  Paper,
  ThemeProvider,
  Tooltip,
  Button,
} from "@mui/material";
import React, { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Logo } from "../../atoms/Logo";
import { FormRecoverPassword } from "./FormRecoverPassword";
import { createTheme } from "@mui/material/styles";
const defaultTheme = createTheme();
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const PageRecoverPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") || "";
  const textTooltip = `La nueva contraseña debe contener entre 8 y 15 caracteres, al menos una mayúscula, una minúscula, un número y un caracter especial (@$!%*?&.,-_'").`;

  useEffect(() => {
    if (token === "") navigate(-1);
  }, [token]);
  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url(https://picsum.photos/2000/2000)",
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[500]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Logo />

            <Avatar sx={{ m: 1, mt: 3 }}></Avatar>
            <Typography
              className="modal-dialog-title"
              component="h1"
              variant="h5"
            >
              {" "}
              Recuperar contraseña
              <Tooltip title={textTooltip}>
              <Button
                size="small"
                sx={{ padding: "0px", minWidth: "30px" }}
                color="info"
              >
                <InfoOutlinedIcon />
              </Button>
            </Tooltip>
            </Typography>

            <FormRecoverPassword token={token} />
            
            <Typography
              className="button-typography"
              variant="body2"
              color="text.secondary"
              align="center"
              sx={{ mt: 5 }}
            >
              {"Copyright © "}
              <Link to="https://ellie.care/" rel="noreferrer" style={{color: 'inherit'}}>
                Ellie Care
              </Link>{" "}
              {new Date().getFullYear()}
              {"."}
            </Typography>

            <Typography
              className="button-typography"
              variant="body2"
              color="text.secondary"
              align="center"
              sx={{ mt: 5 }}
            >
              {"Ya tengo cuenta: "}
              <Link to={`/login`} rel="noreferrer" style={{color: 'inherit'}}>
                Iniciar Sesión
              </Link>
            </Typography>
            
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};
